if (!customElements.get('aw-product-addon')) {
  customElements.define(
    'aw-product-addon',
    class AwProductAddon extends HTMLElement {
      connectedCallback() {
        this.checkbox = this.querySelector('.aw-product-addon__checkbox');
        this.variantId = this.dataset.addonVariantId;
        this.formSelector = this.dataset.mainFormSelector;
        if (!this.checkbox || !this.variantId || !this.formSelector) return;

        this.selectionText = this.querySelector('[data-aw-addon-selection]');
        this.handleSelectionChange = this.handleSelectionChange.bind(this);
        this.checkbox.addEventListener('change', this.handleSelectionChange);
        this.handleSelectionChange();

        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        this.handleCartUpdate = this.handleCartUpdate.bind(this);
        this.unsubscribeCartUpdate = subscribe(PUB_SUB_EVENTS.cartUpdate, this.handleCartUpdate);
      }

      disconnectedCallback() {
        if (this.checkbox) this.checkbox.removeEventListener('change', this.handleSelectionChange);
        if (this.unsubscribeCartUpdate) this.unsubscribeCartUpdate();
      }

      handleSelectionChange() {
        const selected = this.checkbox.checked && !this.checkbox.disabled;
        this.classList.toggle('is-selected', selected);
        if (this.selectionText) this.selectionText.textContent = selected ? 'Added to your order' : 'Tap to add this deal';
      }

      handleCartUpdate(event) {
        if (event.source !== 'product-form' || !this.checkbox.checked || this.checkbox.disabled) return;

        const form = document.querySelector(this.formSelector);
        const variantInput = form ? form.querySelector('[name="id"]') : null;
        if (!variantInput || String(variantInput.value) !== String(event.productVariantId)) return;

        this.addAddonToCart();
      }

      addAddonToCart() {
        const body = {
          items: [{ id: Number(this.variantId), quantity: 1 }],
        };

        if (this.cart) {
          body.sections = this.cart.getSectionsToRender().map((section) => section.id);
          body.sections_url = window.location.pathname;
        }

        fetch(`${routes.cart_add_url}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              console.error('Add-on could not be added to cart:', response.description || response.message);
              return;
            }
            if (this.cart) this.cart.renderContents(response);
          })
          .catch((error) => console.error('Add-on could not be added to cart:', error));
      }
    }
  );
}
